import { useEffect, useState } from "react";
import ProductionSelectionArea from "./components/ProductionSelectionArea";
import TableArea from "./components/TableArea";
import { getCurrentYearAndMonth, toTitleCase } from "@utils/helpers";
import {
  useFetchSidebarProductsQuery,
  useFetchSidebarProductsSubsectionListQuery,
} from "@store/products";
import { REGULATORY_FILLING } from "./data/activeTabs";

export default function ProductInsights() {
  const [activeProduct, setActiveProduct] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [hiddenSidebar, setHiddenSidebar] = useState(false);

  const [selectedDate, setselectedDate] = useState(
    `${toTitleCase(getCurrentYearAndMonth().month)} ${
      getCurrentYearAndMonth().year
    }`
  );

  const {
    data: sidebarProductsSubsectionList,
    isLoading: isSidebarProductsSubsectionListLoading,
    isFetching: isSidebarProductsSubsectionListFetching,
  } = useFetchSidebarProductsSubsectionListQuery(
    {
      ProductId: activeProduct,
      month: selectedDate?.split(" ")[0].toLowerCase(),
      year: selectedDate?.split(" ")[1],
    },
    { skip: !activeProduct, refetchOnMountOrArgChange: true }
  );

  const {
    data: sidebarProducts,
    isLoading: isSidebarProductsLoading,
    isFetching: isSidebarProductsFetching,
  } = useFetchSidebarProductsQuery({
    month: selectedDate?.split(" ")[0].toLowerCase(),
    year: selectedDate?.split(" ")[1],
  });

  const updateQueryWithTabChange = (product, tab = null) => {
    setActiveProduct(Number(product));
    if (tab) {
      setActiveTab(Number(tab));
    } else {
      setActiveTab(null);
    }
  };

  useEffect(() => {
    if (activeProduct) {
      setActiveTab(null);
      setselectedDate(
        `${toTitleCase(getCurrentYearAndMonth().month)} ${
          getCurrentYearAndMonth().year
        }`
      );
    }
  }, [activeProduct]);

  return (
    <div className="h-full flex md:flex-row flex-col gap-2.5 p-2 overflow-x-hidden overflow-y-auto rounded-lg md:p-5 animate-fadeIn bg-secondary-main custom-scrollbar">
      {/* Production Selection Area */}
      <ProductionSelectionArea
        activeProduct={activeProduct}
        activeTab={activeTab}
        updateQueryWithTabChange={updateQueryWithTabChange}
        productList={
          sidebarProducts?.productList ? sidebarProducts?.productList : []
        }
        subsectionList={
          sidebarProductsSubsectionList?.list
            ? sidebarProductsSubsectionList?.list
            : []
        }
        isLoading={
          isSidebarProductsSubsectionListLoading ||
          isSidebarProductsLoading ||
          isSidebarProductsSubsectionListFetching ||
          isSidebarProductsFetching
        }
        hiddenSidebar={hiddenSidebar}
      />
      {/* Table Area */}
      <TableArea
        label={
          //if active tab is reg. filling we will display product  name
          activeTab === REGULATORY_FILLING && hiddenSidebar
            ? sidebarProductsSubsectionList?.list?.find(
                (t) => t.id === activeTab
              )?.displayName +
              " - " +
              sidebarProducts?.productList?.find((t) => t.id === activeProduct)
                ?.name
            : // will show whichever tab is selected wheater its product or sub-product
              sidebarProductsSubsectionList?.list?.find(
                (t) => t.id === activeTab
              )?.displayName ||
              sidebarProducts?.productList?.find((t) => t.id === activeProduct)
                ?.name ||
              "Select a Product"
        }
        selectedDate={selectedDate}
        setselectedDate={setselectedDate}
        activeProduct={activeProduct}
        activeTab={activeTab}
        productsList={sidebarProducts?.productList}
        subsectionList={sidebarProductsSubsectionList?.list}
        isProductListEmpty={
          sidebarProducts?.productList
            ? sidebarProducts?.productList.length === 0
            : sidebarProductsSubsectionList?.list
            ? sidebarProductsSubsectionList?.list?.length === 0
            : false
        }
        setHiddenSidebar={setHiddenSidebar}
        hiddenSidebar={hiddenSidebar}
      />
    </div>
  );
}
